import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { fetchUsersData } from "../../firebase/database"; 
import { useNavigate } from 'react-router-dom';

export default function AdminDashboard() {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const navigate = useNavigate();

  // Navigate to user-specific page
  const handleViewStatus = (orderId) => {
    navigate(`/user/${orderId}`);
  };

  // Fetch users data on component mount or when page changes
  useEffect(() => {
    const loadUsers = async () => {
      setLoading(true);
      const users = await fetchUsersData(page * pageSize, pageSize);
      setTotalUsers(users.length);
      setUsersData(users);
      setLoading(false);
    };
    loadUsers();
  }, [page, pageSize]);

  const columns = [
    { field: "orderId", headerName: "Order ID", width: 100 },
    { field: "name", headerName: "Name", width: 150 },
    { field: "contact", headerName: "Contact", width: 150 },
    { field: "address", headerName: "Address", width: 200 },
    { field: "dateIssued", headerName: "Date Issued", width: 150 },
    { field: "capacity", headerName: "Capacity", width: 130 },
    { field: "voltage", headerName: "Voltage", width: 130 },
    { field: "monitor", headerName: "Monitor", width: 120 },
    {
      field: "link",
      headerName: "Live Status",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleViewStatus(params.row.orderId)}
        >
          View Status
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>

        <Grid container spacing={2} mb={6}>
          {/* Stats */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography variant="h6">Total Users</Typography>
              <Typography variant="h4">{totalUsers}</Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography variant="h6">Active Devices</Typography>
              <Typography variant="h4">
                {Array.isArray(usersData)
                  ? usersData.filter((user) => user.monitor === "Yes").length
                  : 0}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* User Table */}
        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={usersData}
            columns={columns}
            pageSize={pageSize}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            page={page}
            loading={loading}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: { showQuickFilter: true },
            }}
          />
        </Box>
      </Box>
      <Footer />
    </div>
  );
}
